import { PropsWithChildren } from "react";

export const ProductDetailsInfoBidBuyStickyWrapper = ({
  children,
}: PropsWithChildren) => {
  return (
    <div className="empty:hidden fixed bottom-0 left-0 right-0 z-50 whitespace-nowrap border-t border-t-grey-300 bg-white px-2 py-4 shadow-[0px_-2px_40px_0px_rgba(0,0,0,0.10)] md:relative md:border-t-0 md:p-0 md:py-6 md:shadow-none">
      {children}
    </div>
  );
};
